import { useGetConversationsQuery } from "@/api/open-chat";
import * as React from "react";
import { OpenChatConversation } from "@/types/open-chat";
import { SidebarHistoryRow } from "./sidebarHistoryRow";

interface Props {
  conversationId: string;
}

const emptyList: OpenChatConversation[] = [];
export const SidebarHistory: React.FC<Props> = ({ conversationId }) => {
  const { data: conversations = emptyList } = useGetConversationsQuery();

  const sortedConversations = [...conversations].sort((a, b) => (a.created_at < b.created_at ? 1 : -1));

  return (
    <div className="flex flex-grow flex-col overflow-y-scroll bg-white p-4 opacity-80">
      {sortedConversations.map(row => (
        <SidebarHistoryRow key={row.id} conversation={row} selected={row.id === conversationId} />
      ))}
    </div>
  );
};
